import { motion } from "framer-motion";
import { Phone, LogOut } from "lucide-react";
import { SITE } from "../config/site";
import { LogoMark } from "./Logo";

const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -72 });
    else el?.scrollIntoView({ behavior: "smooth" });
};

const Navbar = () => {
    const name = localStorage.getItem("site_name");
    const logout = () => {
        localStorage.removeItem("site_token");
        localStorage.removeItem("site_name");
        window.location.href = "/";
    };
    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="fixed top-0 left-0 right-0 z-50 border-b border-slate-800/80 bg-[#020617]/75 backdrop-blur-xl"
        >
            <div className="max-w-[1440px] mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
                <button
                    data-testid="nav-brand"
                    onClick={() => scrollTo("#top")}
                    className="flex items-center gap-3 font-serif text-2xl text-slate-50 tracking-tight hover:text-sky-400 transition-colors duration-300"
                >
                    <LogoMark size={38} />
                    {SITE.brand}
                </button>
                <nav className="hidden md:flex items-center gap-8 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
                    <button data-testid="nav-link-materie" onClick={() => scrollTo("#materie")} className="hover:text-slate-50 transition-colors duration-300">Materie</button>
                    <button data-testid="nav-link-metodo" onClick={() => scrollTo("#metodo")} className="hover:text-slate-50 transition-colors duration-300">Metodo</button>
                    <button data-testid="nav-link-prezzi" onClick={() => scrollTo("#prezzi")} className="hover:text-slate-50 transition-colors duration-300">Prezzi</button>
                    <button data-testid="nav-link-recensioni" onClick={() => scrollTo("#recensioni")} className="hover:text-slate-50 transition-colors duration-300">Recensioni</button>
                </nav>
                <div className="flex items-center gap-4">
                    <div className="hidden md:flex flex-col items-end gap-0.5">
                        {SITE.tutors.map((t) => (
                            <a
                                key={t.id}
                                data-testid={`nav-phone-${t.id}`}
                                href={t.phoneHref}
                                className="flex items-center gap-2 font-mono text-xs text-slate-300 hover:text-sky-400 transition-colors duration-300"
                            >
                                <Phone size={12} />
                                {t.name} · {t.phoneDisplay}
                            </a>
                        ))}
                    </div>
                    <button
                        data-testid="nav-cta-contatti"
                        onClick={() => scrollTo("#contatti")}
                        className="bg-slate-50 text-[#020617] font-semibold text-sm px-5 py-2 hover:bg-sky-400 transition-colors duration-300"
                    >
                        Contattaci
                    </button>
                    {name ? (
                        <button
                            data-testid="nav-logout-button"
                            onClick={logout}
                            title={`Esci (${name})`}
                            className="inline-flex items-center gap-2 font-mono text-xs text-slate-500 hover:text-red-400 transition-colors duration-300"
                        >
                            <LogOut size={14} />
                            <span className="hidden lg:inline">{name} · Esci</span>
                        </button>
                    ) : (
                        <a
                            data-testid="nav-login-link"
                            href="/accedi"
                            className="inline-flex items-center gap-2 font-mono text-xs text-slate-400 hover:text-sky-400 transition-colors duration-300"
                        >
                            <LogOut size={14} className="rotate-180" />
                            Accedi
                        </a>
                    )}
                </div>
            </div>
        </motion.header>
    );
};

export default Navbar;
